/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalySummaryResource {
    getFixupPrototypeFunction() { return CostAnomalySummaryResource.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalySummaryResource>): CostAnomalySummaryResource {
        let obj = Object.assign(new CostAnomalySummaryResource(), model);
        CostAnomalySummaryResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalySummaryResource>): CostAnomalySummaryResource {
        if (!model) return null;
        return CostAnomalySummaryResource.newInstance(<CostAnomalySummaryResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalySummaryResource) {
        if (!obj) return;

        models.CostAnomalySummaryResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalySummaryResource): boolean {
        Object.setPrototypeOf(obj, CostAnomalySummaryResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.bill_date === "string") {
            this.bill_date = new Date(<string><any>this.bill_date);
        }
        if (this.anomalies) {
            for (let val of this.anomalies) {
                models.CostAnomalyResourceDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * service account id
     */
    service_account_id: string;

    /**
     * Time of results
     */
    bill_date: Date;

    /**
     * Name of the Product category
     */
    product_category: string;

    /**
     * Name of the Resource category
     */
    resource_category: string;

    /**
     * categories wise daily cost anomaly summary
     */
    anomalies: Array<models.CostAnomalyResourceDetails>;

    /**
     * Records based on the actual metric that is used during anomaly detection
     */
    billing_source: string;

}
